import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import 'rxjs/add/operator/map';

import {AuthenticationService} from '../authentication.service';

import { CookieService } from 'ngx-cookie-service';

declare var $: any;

@Component({
  selector: 'app-simple-layout',
  providers: [AuthenticationService],
  templateUrl: './simple-layout.component.html',
  styleUrls: ['./simple-layout.component.css']
})
export class SimpleLayoutComponent implements OnInit {

  constructor(private http: Http, private router: Router,private _service:AuthenticationService, private cookieService: CookieService) { }

  ngOnInit() {
    if(localStorage.getItem("Id") != ''){
      
      if(localStorage.getItem("userrole") == '1' ){  
        this.router.navigate(['Supplier']);  
      }
      if(localStorage.getItem("userrole") == '2' ){  
        this.router.navigate(['Parent']);  
      }
      if(localStorage.getItem("userrole") == '3'){
        this.router.navigate(['Product-stock']);  
      }
      if(localStorage.getItem("userrole") == '4' ){  
        this.router.navigate(['Parent']);  
      }
      if(localStorage.getItem("userrole") == '5' ){  
        this.router.navigate(['Order']);  
      }
      if(localStorage.getItem("userrole") == '6'){
        this.router.navigate(['Expense']);    
      }
    }
  }

  login : any={};
  errors = 0;
  errorMsg: String;

 
  someMethod(event:any){
    if(event.keyCode == 13){
      // alert("hiii");
       this.onSubmit(this.login);
    }
 }

  onSubmit(login: any) {

  	 let headers = new Headers({ 'Content-Type': 'application/json'});
      let options = new RequestOptions({ headers: headers });
   
     
    let body = JSON.stringify(login);

    //console.log(body);

  //   let user = $('#name').val();
  //   let pass = $('#password').val();

  //   if(!this._service.login(this.login.name , this.login.password)){
  //     this.errorMsg = 'Username or Password wrong...';
  // }

    if(login.name == '' || login.password == null){
       this.errors++;
       $('#reqerr').removeClass('error');
    }else{
      this.errors = 0;
      $('#reqerr').addClass('error');
    }
    
   
  //  alert(this.errors);
    if(this.errors == 0){
      
      this.http.post('webservice.php?action=userlogin',body )
      .map(res => res.json())
      .subscribe(
          response => {
          //	alert(response.status);
          if(response.status == 'success'){      
            localStorage.setItem("Id", response.result.Id);
            localStorage.setItem("username", response.result.user);
            localStorage.setItem("userrole", response.result.role);
            localStorage.openpages = Date.now();
            var date = new Date();
            var minutes = 1;  
            var time = date.getTime() + ((3600 * 1000) * 12);
            date.setTime(time);      
            this.cookieService.set( 'login', 'on', date );
            //this.cookieService.set( 'login', 'on', (60 * 1) );   
             
            if(response.result.role == 1){
              this.router.navigate(['Supplier']);   
            }
            if(response.result.role == 2){
                  this.router.navigate(['Parent']);
                }
                if(response.result.role == 3){
                  this.router.navigate(['Product-stock']);
                }  
          
                if(response.result.role == 4){
                  this.router.navigate(['Parent']);
                }  

                if(response.result.role == 5){
                  this.router.navigate(['Order']);
                }
                
                if(response.result.role == 6){
                  this.router.navigate(['Expense']);    
                }
          	 //this.router.navigate(['Farmer']); 
          }else{
        	  $('#wrgerr').removeClass('error');
          }

          }, //For Success Response  
          err => {console.error(err)} //For Error Response
      ); 
    }
  }
}
